import api from './axios';

export const fetchSalonDashboard = () =>
  api.get('/analytics/dashboard').then((r) => r.data);

export const fetchAnalyticsOverview = (params) =>
  api.get('/analytics/overview', { params }).then((r) => r.data);

export const fetchIncomeChart = (params) =>
  api.get('/analytics/income-chart', { params }).then((r) => r.data);

export const fetchBranchComparison = () =>
  api.get('/analytics/branch-comparison').then((r) => r.data);

export const fetchTopServices = (params) =>
  api.get('/analytics/top-services', { params }).then((r) => r.data);

export const fetchTopProducts = (params) =>
  api.get('/analytics/top-products', { params }).then((r) => r.data);

export const fetchStaffPerformance = (params) =>
  api.get('/analytics/staff-performance', { params }).then((r) => r.data);

export const fetchStaffDailyWork = (params) =>
  api.get('/analytics/staff-daily-work', { params }).then((r) => r.data);

export const fetchPosDailyIncome = (params) =>
  api.get('/analytics/pos-daily-income', { params }).then((r) => r.data);

export const exportReport = async (params) => {
  const response = await api.get('/reports/export', {
    params,
    responseType: 'blob',
  });

  const ext = params.format === 'pdf' ? 'pdf' : 'csv';
  const blob = new Blob([response.data], {
    type: params.format === 'pdf' ? 'application/pdf' : 'text/csv',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `aurabook-${params.type}-report.${ext}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
